import * as React from 'react';
import { useColorScheme } from 'react-native';
import { useRecoilValue } from 'recoil';

import * as analytics from '@gitbook/app-analytics/client';
import { UserTheme } from '@gitbook/app-database';
import { ConfigurationTheme } from '@gitbook/react-uikit';
import { ThemeProvider } from '@gitbook/spine-react';
import { usePrevious } from '@gitbook/util-react-hooks';

import { useCurrentUser } from '../auth';
import { userThemeAtom } from '../locals';

/*
 * Provide all user data as a context.
 *
 * We try to do many request in parallel as to only suspend once.
 */
export function UserDataProvider(props: { children: React.ReactNode }): React.ReactElement {
    const { children } = props;
    const user = useCurrentUser();
    const defaultColorScheme = useColorScheme();
    const userTheme = useRecoilValue(userThemeAtom);

    // Identify the user everytime it changes
    const prevUserId = usePrevious(user?.uid);
    React.useEffect(() => {
        if (user?.uid !== prevUserId) {
            analytics.identify();
        }
    }, [user?.uid, prevUserId]);

    const theme = userTheme === UserTheme.Default ? defaultColorScheme : userTheme;

    return (
        <ConfigurationTheme theme={{ color: theme || undefined }}>
            <ThemeProvider value={theme || 'light'}>{children}</ThemeProvider>
        </ConfigurationTheme>
    );
}
